export const licenseTypeApiMapper = {
  evaluation: ['evaluation'],
  paid: ['commercial', 'academic'],
  free: ['community', 'demonstration', 'open_source', 'free']
};
const updateParamsForLicenseType = queryParams => {
  const licenseType = queryParams.licenseType;
  if (licenseType) {
    if (Array.isArray(licenseType)) {
      let types = [];
      licenseType.forEach(type => {
        var _licenseTypeApiMapper;
        types = [...types, ...((_licenseTypeApiMapper = licenseTypeApiMapper[type]) !== null && _licenseTypeApiMapper !== void 0 ? _licenseTypeApiMapper : [])];
      });
      queryParams.licenseType = types;
    } else {
      queryParams.licenseType = licenseTypeApiMapper[licenseType];
    }
  }
  return queryParams;
};
export const mapQueryParamsToApiParams = queryParams => {
  queryParams = updateParamsForLicenseType(queryParams);
  return queryParams;
};